// Screens: 08-member-history, 31-holder-events-tab
// Event timeline for a subscription.

import { Page } from '@/shared/ui/Page';
import { PageHeader } from '@/shared/ui/PageHeader';
import { useT } from '@/shared/lib/i18n';

export function HistoryPage() {
  const t = useT();

  return (
    <Page>
      <PageHeader title={<span className="font-bold text-[19px]">{t('pages.history')}</span>} />
      <div className="px-[18px]">
        {/* TODO: EventRow list (TG-UI: Timeline) */}
      </div>
    </Page>
  );
}
